var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFramerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 876,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020617",
    d: "M0 0h1440v876H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    d: "M2072.65 305.709c22.73-314.792-512.88-609.987-1196.32-659.336C192.891-402.976-379.572-187.792-402.302 127c-22.731 314.792 512.88 609.987 1196.319 659.337C1477.46 835.686 2049.92 620.501 2072.65 305.709z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    d: "M2027.16 239.986c8.92-307.77-525.63-572.966-1193.944-592.335C164.899-371.717-384.11-137.922-393.029 169.847c-8.919 307.769 525.628 572.967 1193.945 592.335C1469.23 781.55 2018.24 547.755 2027.16 239.986z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#d)",
    d: "M808.291 738.348C1461.38 727.746 1986.85 475.315 1981.96 174.527c-4.88-300.787-538.27-536.03-1191.351-525.429C137.525-340.3-387.947-87.869-383.064 212.919c4.883 300.788 538.27 536.03 1191.355 525.429z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    d: "M815.349 714.312C1453.27 673.73 1955.26 402.655 1936.57 108.85c-18.69-293.806-550.98-499.085-1188.906-458.503C109.741-309.071-392.246-37.996-373.555 255.809c18.69 293.806 550.981 499.085 1188.904 458.503z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f)",
    d: "M822.268 690.364C1445.1 619.841 1923.69 330.188 1891.22 43.406c-32.47-286.782-563.71-462.095-1186.543-391.572C81.841-277.643-396.744 12.01-364.272 298.792c32.472 286.782 563.704 462.094 1186.54 391.572z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M829.052 666.611C1436.69 566.127 1891.76 257.801 1845.48-22.054 1799.2-301.91 1269.1-447.318 661.459-346.834 53.824-246.349-401.246 61.977-354.966 341.832c46.279 279.855 576.382 425.264 1184.018 324.779z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#h)",
    d: "M836.188 642.545C1428.7 512.057 1860.31 185.126 1800.23-87.677c-60.08-272.802-589.1-388.171-1181.608-257.683C26.115-214.872-405.504 112.059-345.424 384.862c60.079 272.803 589.105 388.171 1181.612 257.683z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#i)",
    d: "M843.137 618.704C1420.44 458.278 1828.54 112.7 1754.66-153.168c-73.89-265.867-601.77-351.346-1179.072-190.921-577.3 160.425-985.402 506.004-911.52 771.872 73.881 265.867 601.769 351.346 1179.069 190.921z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#j)",
    d: "M850.281 594.491C1412.37 404.016 1796.93 39.789 1709.22-219.033c-87.71-258.823-614.47-314.23-1176.555-123.755-562.087 190.474-946.647 554.701-858.939 813.524 87.707 258.822 614.469 314.229 1176.555 123.755z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#k)",
    d: "M857.348 570.614C1404.32 350.179 1765.44-32.684 1663.94-284.535s-627.18-277.319-1174.152-56.884C-57.182-120.985-418.306 261.879-316.807 513.73c101.499 251.851 627.186 277.319 1174.155 56.884z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#l)",
    d: "M864.354 546.867C1396.16 296.506 1733.8-105.002 1618.49-349.926c-115.3-244.924-639.888-240.516-1171.691 9.845C-85.005-89.72-422.644 311.788-307.34 556.712c115.305 244.924 639.89 240.516 1171.694-9.845z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#m)",
    d: "M871.479 522.744C1388.09 242.365 1702.2-177.803 1573.07-415.729c-129.13-237.925-652.601-203.51-1169.21 76.869-516.608 280.378-830.721 700.547-701.592 938.472 129.129 237.926 652.603 203.511 1169.211-76.868z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#n)",
    d: "M878.397 498.831C1379.86 188.514 1670.55-250.23 1527.67-481.13c-142.89-230.9-665.239-166.519-1166.706 143.799C-140.504-27.014-431.193 411.73-288.307 642.63c142.885 230.9 665.236 166.519 1166.704-143.799z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#o)",
    d: "M885.552 474.659C1371.84 134.284 1639.02-323.139 1482.31-547.024 1325.6-770.908 804.351-676.474 318.064-336.099-168.223 4.277-435.4 461.7-278.693 685.584c156.708 223.885 677.958 129.451 1164.245-210.925z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#p)",
    d: "M892.386 450.536C1363.52 80.191 1607.2-395.898 1436.67-612.839c-170.53-216.94-690.7-92.581-1161.833 277.765C-196.295 35.271-439.981 511.36-269.449 728.301c170.531 216.94 690.703 92.581 1161.835-277.765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#q)",
    d: "M899.207 426.746C1355.21 26.418 1575.48-468.288 1391.19-678.21 1206.9-888.133 687.833-733.778 231.828-333.45-224.177 66.878-444.444 561.584-260.153 771.506c184.292 209.923 703.355 55.568 1159.36-344.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#r)",
    d: "M906.247 402.707C1347.02-27.58 1543.77-540.888 1345.69-743.798c-198.08-202.91-715.98-18.585-1156.757 411.702C-251.845 98.191-448.589 611.499-250.509 814.409c198.081 202.911 715.978 18.585 1156.756-411.702z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#s)",
    d: "M913.313 378.765C1338.94-81.513 1512.2-613.49 1300.29-809.439c-211.9-195.951-728.716 18.333-1154.342 478.611C-279.678 129.45-452.935 661.428-241.033 857.376c211.902 195.954 728.72-18.332 1154.346-478.611z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#t)",
    d: "M920.231 354.755C1330.71-135.481 1480.55-686.063 1254.9-875.004c-225.65-188.946-741.34 55.306-1151.823 545.542-410.483 490.236-560.319 1040.818-334.668 1229.76 225.65 188.942 741.339-55.307 1151.822-545.543z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#u)",
    d: "M927.246 330.652C1322.54-189.557 1448.87-758.769 1209.42-940.719 969.97-1122.67 455.412-848.456 60.122-328.247c-395.29 520.21-521.623 1089.422-282.173 1271.372 239.45 181.955 754.007-92.263 1149.297-612.473z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#v)",
    d: "M934.269 306.673C1314.36-243.485 1417.2-831.311 1163.95-1006.27 910.708-1181.24 397.285-877.081 17.19-326.924-362.907 223.234-465.74 811.06-212.495 986.022 40.751 1160.99 554.174 856.83 934.269 306.673z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#w)",
    d: "M941.337 283.109C1306.37-297.001 1385.8-903.496 1118.75-1071.54 851.7-1239.58 339.297-905.527-25.735-325.417-390.767 254.693-470.198 861.188-203.148 1029.23c267.05 168.04 779.453-166.011 1144.485-746.121z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 835.173,
    x2: 835.173,
    y1: -1115,
    y2: 1072.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#F97316"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v876H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramerBg);
export default __webpack_public_path__ + "static/media/framerBg.3ecae0a7dbba0baf2576a75a192069f2.svg";
export { ForwardRef as ReactComponent };